import { COMPANY, NAV_LINKS } from "@/lib/constants";

export const Footer = () => {
    return (
        <footer
            data-testid="site-footer"
            className="bg-ink text-bone py-20 md:py-24 border-t border-bone/10"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="grid md:grid-cols-12 gap-10 md:gap-12">
                    <div className="md:col-span-5">
                        <div className="flex items-center gap-3 mb-5">
                            <span className="inline-flex h-10 w-10 items-center justify-center bg-bone text-ink font-heading font-semibold text-base tracking-tight">
                                H<span className="text-terracotta">₂</span>N
                            </span>
                            <div>
                                <div className="font-heading text-xl font-medium tracking-tight">
                                    {COMPANY.shortName}, LLC
                                </div>
                                <div className="text-[11px] uppercase tracking-[0.22em] text-bone/55 font-semibold">
                                    Waterwise Landscape Subcontractor
                                </div>
                            </div>
                        </div>
                        <p className="text-bone/65 leading-relaxed max-w-md text-sm">
                            Insured landscape subcontractor delivering artificial turf, xeriscape,
                            retaining walls, hardscapes, and fencing across the Wasatch Front for
                            general contractors and developers.
                        </p>
                    </div>

                    <div className="md:col-span-3">
                        <div className="text-[10px] uppercase tracking-[0.25em] font-bold text-bone/45 mb-5">
                            Navigate
                        </div>
                        <ul className="space-y-3">
                            {NAV_LINKS.map((l) => (
                                <li key={l.href}>
                                    <a
                                        href={l.href}
                                        className="text-bone/85 hover:text-terracotta transition-colors text-sm"
                                    >
                                        {l.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <div className="text-[10px] uppercase tracking-[0.25em] font-bold text-bone/45 mb-5">
                            Contact
                        </div>
                        <ul className="space-y-3 text-sm">
                            <li>
                                <a href={`mailto:${COMPANY.email}`} className="text-bone/85 hover:text-terracotta transition-colors">
                                    {COMPANY.email}
                                </a>
                            </li>
                            <li>
                                <a href={`tel:${COMPANY.phone}`} className="text-bone/85 hover:text-terracotta transition-colors">
                                    {COMPANY.phone}
                                </a>
                            </li>
                            <li className="text-bone/65">{COMPANY.address}</li>
                        </ul>
                    </div>
                </div>

                {/* Mega wordmark */}
                <div className="mt-20 md:mt-24 border-t border-bone/10 pt-10">
                    <div className="font-heading text-[18vw] md:text-[14vw] leading-none tracking-tighter font-medium text-bone/10 select-none">
                        H<span className="text-terracotta/30">₂</span>NO UTAH
                    </div>
                </div>

                <div className="mt-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[11px] text-bone/45">
                    <p>© {new Date().getFullYear()} H2No Utah, LLC. All rights reserved.</p>
                    <p className="uppercase tracking-[0.22em]">UT DOPL Licensed · Insured</p>
                </div>
            </div>
        </footer>
    );
};
